import React from "react";
import cn from "classnames";
import styles from "./iframe-error.module.scss";

/**
 * Props for `IFrame.Error`.
 *
 * Minimal, unopinionated error view—override classes to style.
 */
export type IFrameErrorProps = {
  error: unknown;
  title?: string;
  formatMessage?: (error: unknown) => string | null | undefined;
  className?: string;
  titleClassName?: string;
  messageClassName?: string;
};

/**
 * Default error content for `IFrame.Query`.
 *
 * Used when no `renderError` override is provided.
 */
export const IFrameError: React.FC<IFrameErrorProps> = ({
  error,
  title = "Could not load content.",
  formatMessage = (e) => (e instanceof Error ? e.message : String(e ?? "")),
  className,
  titleClassName,
  messageClassName,
}) => {
  const message = formatMessage?.(error);
  return (
    <div className={cn(styles.errorRoot, className)}>
      <div className={cn(styles.errorTitle, titleClassName)}>{title}</div>
      {message ? (
        <div className={cn(styles.errorMessage, messageClassName)}>
          {message}
        </div>
      ) : null}
    </div>
  );
};

IFrameError.displayName = "IFrame.Error";
